import { Container, ContainerSucces } from './styles'
import { toast, ToastContainer } from 'react-toastify'
import ReCAPTCHA from 'react-google-recaptcha'
import { useEffect, useState } from 'react'
import validator from 'validator'
import axios from 'axios';

export function Form() {
  const [validEmail, setValidEmail] = useState(false)
  const [isHuman, setIsHuman] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e:any) =>{
    e.preventDefault();

    if(email !== "" && message !== ""){
      const body = {
        email,
        message, 
      }
      await axios.post(`https://abdulnasirolcan.vercel.app/mail`, body, {
        headers: {
          'Content-type': 'application/json'
        }
      }).then((response: any)=>{
        if (response.data.status === 'success'){
          toast.success('Email successfully sent!', {
            position: toast.POSITION.BOTTOM_CENTER,
            pauseOnFocusLoss: false,
            closeOnClick: true,
            hideProgressBar: false,
            toastId: 'succeeded',
          })
          setIsSuccess(true)
          resetForm()
        }else if(response.data.status === 'fail'){
            toast.error('Message failed to send!', {
              position: toast.POSITION.BOTTOM_CENTER,
              pauseOnFocusLoss: false,
              closeOnClick: true,
              hideProgressBar: false,
              toastId: 'errored',
            })
        }
      })
    }


}
const resetForm = () =>{
  setEmail('')
  setMessage('')
}


  function verifyEmail(email: string) {
    if (validator.isEmail(email)) {
      setEmail(email)
      setValidEmail(true)
    } else {
      setValidEmail(false)
    }
  }

  useEffect(() => {
    if (isSuccess) {
      toast.success('Email successfully sent!', {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        hideProgressBar: false,
        toastId: 'succeeded',
      })
    }
  })

  if (isSuccess) {
    return (
      <ContainerSucces>
        <h3>Thank you for contacting me!</h3>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          Back to top
        </button>
        <ToastContainer />
      </ContainerSucces>
    )
  }

  return (
    <Container>
      <h2>Get in touch using the form below</h2>
      <form onSubmit={handleSubmit} method="post">
        <input
          placeholder="Email"
          id="email"
          type="email"
          name="email"
          value = {email}
          onChange={(e) => {
            verifyEmail(e.target.value)
          }}
          required
        />
        <textarea
          required
          placeholder="Leave your message"
          id="message"
          name="message" 
          value = {message}
          onChange={(e) => {
            setMessage(e.target.value)
          }}
        />
        <ReCAPTCHA
          sitekey="6Ldt0rgeAAAAANnkGOp6xKECIXVx0tqijbE0Nu7x"
          onChange={(e) => {
            setIsHuman(true)
          }}
        ></ReCAPTCHA>
        <button
          type="submit"
          disabled={!validEmail || !message || !isHuman}
        >
          Send
        </button>
      </form>
      <ToastContainer />
    </Container>
  )
}
